export function Spinner({ fullscreen = false, label }: { fullscreen?: boolean; label?: string }) {
  const spinner = (
    <div className="flex flex-col items-center gap-3 text-ink-3" role="status">
      <div className="h-7 w-7 animate-spin rounded-full border-2 border-line border-t-ink" />
      {label && <p className="text-[14px]">{label}</p>}
      <span className="sr-only">Loading</span>
    </div>
  )
  return fullscreen ? <div className="grid h-full place-items-center">{spinner}</div> : spinner
}
